<template>
  <div>
    <section-title
      has-line
      content="Certificación Medicaid"
      :class="{ 'section-title': isMobile }"
    />
    <npi
      ref="npi"
      label="NPI DEPR"
      :value="school.nationalIdentifier"
      @save="saveNpi"
    />

    <div v-if="showCertificacions">
      <custom-separator
        text="Certificaciones"
        class="my-4 custom-separator-line"
      />

      <div v-if="adding" class="bg-secondary-3 rounded p-4 mb-3">
        <certification-form
          v-model="model"
          :document-types="documentTypes"
          @save="save"
          @cancel="cancel"
        />
      </div>
      <div v-if="school.medicaidCertifications?.length">
        <div v-if="!adding" class="d-flex justify-content-end mb-3">
          <action-button
            class="btn-mobile px-3"
            variant="success"
            i="fas fa-file-plus"
            text="Añadir"
            @click="adding = true"
            :disabled="isEditingNpi"
          />
        </div>
        <certification-row
          v-for="(item, index) in school.medicaidCertifications"
          :key="index"
          :item="item"
        />
      </div>
      <div v-else-if="!adding" class="bg-secondary-3 rounded p-4">
        <div class="d-flex align-items-center justify-content-center">
          <button
            class="btn bg-light-white"
            @click="adding = true"
            :disabled="isEditingNpi"
          >
            <i class="fas fa-file-plus mr-2 text-green" />
            <span>
              Presione aquí para añadir Certificación Medicaid
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomSeparator from 'custom-separator';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';

import Npi from '@/components/Npi.vue';
import CertificationForm from './MedicaidCertificationForm.vue';
import CertificationRow from './MedicaidCertificationRow.vue';

import schoolApi from '@/modules/school-management/api';
import { Categories } from '@/utils/constants/documentTypes';
import * as catalogApi from '@/views/pei/location-alternatives/_api';

export default {
  name: 'MedicaidCertification',
  components: {
    ValidationObserver,
    ValidationProvider,
    SectionTitle,
    CustomInput,
    CustomSeparator,
    ActionButton,
    IconView,
    Npi,
    CertificationForm,
    CertificationRow,
  },
  props: {
    school: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      adding: false,
      documentTypes: [],
      model: {},
    };
  },
  async mounted() {
    await this.getDocumentTypes();
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    showCertificacions() {
      return Boolean(this.school.nationalIdentifier);
    },
    isEditingNpi() {
      return this.$refs.npi?.editing ?? false;
    },
  },
  methods: {
    async saveNpi(value, callback) {
      await schoolApi.setNpi(this.school.locationSchoolId, value);
      this.school.nationalIdentifier = value;
      if (callback) callback();
    },
    async getDocumentTypes() {
      const documentTypes = await catalogApi.getDocumentTypesByCategory(
        Categories.OtherMedicaidCertificationDocument
      );
      this.documentTypes = documentTypes;
    },
    async save(item) {
      this.school.medicaidCertifications.unshift(item);
      this.cancel();
    },
    cancel() {
      this.adding = false;
    },
  },
};
</script>

<style scoped>
.custom-icon-view ::v-deep > div:first-child {
  background-color: white !important;
  margin-right: 10px !important;
}

.custom-icon-view ::v-deep > div:last-child {
  font-weight: normal !important;
  color: black !important;
}
</style>
